/**
 * Invoice status constants
 */
export const INVOICE_STATUS_PAID = 'paid';
export const INVOICE_STATUS_PENDING = 'pending';

/**
 * Invoice item status constants
 */
// User has started but not submitted the application
export const INVOICE_ITEM_STATUS_STARTED = 'started';

// User's application is not yet approved by admin
export const INVOICE_ITEM_STATUS_PENDING = 'pending';

// User's application has been waitlisted by admin
export const INVOICE_ITEM_STATUS_WAITLISTED = 'waitlisted';

// User's application has been rejected by admin
export const INVOICE_ITEM_STATUS_REJECTED = 'rejected';

// User is ready to create an invoice and pay for the associated product
export const INVOICE_ITEM_STATUS_INVOICEABLE = 'invoiceable';

// Invoice has been created for the invoice item but not paid for
export const INVOICE_ITEM_STATUS_INVOICED = 'invoiced';

// Invoice item has been paid, but user not enrolled
// (should not see this state on the front-end)
export const INVOICE_ITEM_STATUS_PAID = 'paid';

// Invoice item has been completed, but user not enrolled
// (should not see this state on the front-end)
export const INVOICE_ITEM_STATUS_COMPLETE = 'complete';

// User has been enrolled in the session for the associated product
export const INVOICE_ITEM_STATUS_ENROLLED = 'enrolled';

/**
 * Payment status constants
 */
export const PAYMENT_STATUS_PAID = 'paid';
export const PAYMENT_STATUS_IN_PROCESS = 'in-process';
export const PAYMENT_STATUS_FAILED = 'failed';

/**
 * Payment type constants
 */
export const PAYMENT_TYPE_PAYPAL = 'paypal';
export const PAYMENT_TYPE_STRIPE = 'stripe';

/**
 * Payment source type constants
 */
export const PAYMENT_SOURCE_TYPE_PAYPAL = 'paypal';
export const PAYMENT_SOURCE_TYPE_STRIPE = 'stripe';

/**
 * Product type constants
 */
export const PRODUCT_TYPE_COURSE = 'course';
export const PRODUCT_TYPE_TRACK = 'track';

/**
 * Product visibility constants
 */
export const PRODUCT_VISIBILITY_PUBLIC = 'public';
export const PRODUCT_VISIBILITY_PRIVATE = 'private';
export const PRODUCT_VISIBILITY_UNLISTED = 'unlisted';

/**
 * Organization constants
 */
export const ORGANIZATION_CATALOG_TYPE_MULTI = 'multi';
export const ORGANIZATION_CATALOG_TYPE_SINGLE = 'single';
export const ORGANIZATION_CATALOG_TYPE_PRIVATE = 'private';

/**
 * Membership constants
 */
export const MEMBERSHIP_TYPE_ADMIN = 'administrator';
export const MEMBERSHIP_TYPE_OWNER = 'owner';
export const MEMBERSHIP_TYPE_STUDENT = 'student';

/**
 * URL constants
 */
export const DEFAULT_TERMS_OF_SERVICE_URL = '/policies/terms-of-use';

/**
 * OAuth constants
 */
export const OAUTH_PROVIDERS = {
	CUSTOM: 'custom',
	GOOGLE: 'google',
	LINKEDIN: 'linkedin',
	MIRO: 'miro',
	ZOOM: 'zoom',
};

export const OAUTH_TYPES = {
	API: 'api',
	SSO: 'sso',
};

export const SUBSCRIPTION_NOTIFICATION_TYPES = {
	COMMENT: 'discussion-comment',
	EVENT_REMINDER: 'event-reminder',
	EVENT_RSVP: 'event-rsvp',
	MENTON: 'mention',
	REPLY: 'discussion-reply',
};

export const SUBSCRIPTION_OBJECT_TYPES = {
	CHANNEL: 'channel',
	EVENT: 'event',
	THREAD: 'thread',
};

export const ENROLLMENT_TYPES = {
	GUEST: 'guest',
	STUDENT: 'student',
	GUEST_EXPERT: 'guest-expert',
	FACILITATOR: 'facilitator',
	CONTENT_EDITOR: 'editor',
	ADMIN: 'administrator',
};

/**
 * The error codes related to usage of magic login tokens.
 */
export const MAGIC_LOGIN_TOKEN_ERROR_CODES = {
	EXPIRED: 'magic-login-token-expired',
	INVALID: 'magic-login-token-invalid',
	MISSING: 'magic-login-token-missing',
	MISSING_NAMES: 'magic-login-token-missing-first-and-last-names',
};
